import { Controller } from "@hotwired/stimulus"
import { CHANGE, KEY, readBench } from "../lib/bench_store"

// Links that change once an owner has a workbench on this phone: "Build my workbench" turns into "Open my
// workbench", and the way back to it appears on every tool. The page is drawn for someone without one, so it reads
// right without JavaScript; the `kept` targets show and the `fresh` ones hide when a workbench is found.
export default class extends Controller {
  static targets = ["fresh", "kept"]

  connect() {
    this.update = this.update.bind(this)
    this.other = (event) => event.key === KEY && this.update()
    this.update()
    window.addEventListener(CHANGE, this.update)
    window.addEventListener("storage", this.other)
  }

  disconnect() {
    window.removeEventListener(CHANGE, this.update)
    window.removeEventListener("storage", this.other)
  }

  update() {
    const kept = !!readBench()
    this.freshTargets.forEach((element) => (element.hidden = kept))
    this.keptTargets.forEach((element) => (element.hidden = !kept))
  }
}
